import { routes } from "@prmf/site-router";
import CallToAction from "./CallToAction";

export default function AccreditationsCTA() {
  return (
    <CallToAction
      title="Accreditations and Certifications"
      image="/media/assets/accreditations-header.jpg"
      text="Outstanding products, first class service and sustainable processes"
      overlay={60}
      to={routes.accreditations}
    />
  );
}
